// extracted by mini-css-extract-plugin
export default {"root":"AdminMenu_root__fsMCd","settingsContainer":"AdminMenu_settingsContainer__kUbHJ","tabs":"AdminMenu_tabs__vXWmG","spanContainer":"AdminMenu_spanContainer__1IIzz"};